import { Box, Button, Paper, Typography } from '@mui/material';
import type React from 'react';

interface Props {
  onNext: () => void;
  onBack: () => void;
}

const ProcurementStep2HowItWorks: React.FC<Props> = ({ onNext, onBack }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        How it Works
      </Typography>
      <Typography variant="body1">
        BIDLOGIQ separates the procurement process into distinct, secure workspaces.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper variant="outlined" sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box
            sx={{ p: 1, bgcolor: 'info.main', color: 'white', borderRadius: 1, fontWeight: 'bold' }}
          >
            1
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Extract & Standardize
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Start by uploading your RFP documents. Our AI will automatically extract the
              procurement details and structure a standardized evaluation rubric for you.
            </Typography>
          </Box>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box
            sx={{
              p: 1,
              bgcolor: 'warning.main',
              color: 'white',
              borderRadius: 1,
              fontWeight: 'bold',
            }}
          >
            2
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Compliance & Triage
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Once suppliers submit their documents, run the Compliance and Contradiction Detection
              engines to extract mandatory forms and flag internal risks instantly.
            </Typography>
          </Box>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box
            sx={{
              p: 1,
              bgcolor: 'success.main',
              color: 'white',
              borderRadius: 1,
              fontWeight: 'bold',
            }}
          >
            3
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Assess & Moderate
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Evaluators score bids independently to prevent bias. Finally, the Panel Chair uses the
              Moderation Console to synthesize a consensus report for the audit trail.
            </Typography>
          </Box>
        </Paper>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button variant="text" color="inherit" onClick={onBack} size="large">
          Back
        </Button>
        <Button variant="contained" color="primary" onClick={onNext} size="large">
          Next: Complete Setup
        </Button>
      </Box>
    </Box>
  );
};

export default ProcurementStep2HowItWorks;
